import { PromptTemplateProvider } from 'pages/admin/prompts/prompt.context';
import React from 'react';
import { PromptTitles } from 'pages/admin/prompts/tabs/prompt.titles';
import { PromptBullets } from 'pages/admin/prompts/tabs/prompt.bullets';
import { PromptDescription } from 'pages/admin/prompts/tabs/prompt.description';
import { PromptSystem } from 'pages/admin/prompts/tabs/prompt.system';
import { usePromptOptimizer } from 'pages/admin/prompts/optimizer/prompt-optimizer.hooks';
import { useParams } from 'react-router-dom';
import { Button } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons';

const tabs = {
  title: PromptTitles,
  bullets: PromptBullets,
  description: PromptDescription,
  system: PromptSystem,
};

const PromptOptimizer = () => {
  const { tabValue } = useParams();
  const { context, update } = usePromptOptimizer();
  const TabPanel = tabs[tabValue || 'title'];

  return (
    <>
      <PromptTemplateProvider data={{ ...context }}>
        <TabPanel />
      </PromptTemplateProvider>
      <Button className="my-2" onClick={update} leftIcon={<IconDeviceFloppy size="1rem" />}>
        Save Optimizer
      </Button>
    </>
  );
};

export default PromptOptimizer;
